import React, { forwardRef } from 'react';
import MuiListItemText, { ListItemTextProps as MuiListItemTextProps } from '@mui/material/ListItemText';
import { BpDesignSystem } from '../../types';
import { Typography, type TypographyProps } from '../Typography';

export type ListItemTextProps = BpDesignSystem.PropsWithChildren<
  Omit<MuiListItemTextProps, 'slotProps'> & {
    slotProps?: {
      primary?: TypographyProps;
      secondary?: TypographyProps;
    };
  }
>;

/**
 * This is ex-MenuListLabel component
 */
export const ListItemText = forwardRef<HTMLDivElement, ListItemTextProps>(
  ({ dataTest, slots, slotProps, ...props }, ref) => {
    return (
      <MuiListItemText
        ref={ref}
        data-test={dataTest}
        {...props}
        slots={{
          primary: Typography,
          secondary: Typography,
          ...slots
        }}
        slotProps={{
          ...slotProps,
          primary: {
            variant: 'label',
            large: true,
            component: 'div',
            ...slotProps?.primary
          },
          secondary: {
            variant: 'body',
            small: true,
            ...slotProps?.secondary
          }
        }}
      />
    );
  }
);
